module.exports = __webpack_public_path__ + "img/bg.74234c63.png";